module.exports = __webpack_public_path__ + "static/img/203.9954fc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200921/203.jpg
// module id = O6dy
// module chunks = 0